/**
 *
 * LoyaltyAssist Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */

import {
  lazyLoyaltyAssistPage,
  lazyLoyaltyTransitionHistoryPage,
  lazyLoyaltyUsersPage,
  lazyTaxHistoryPage,
} from './lazyLoyaltyAssist';

// routes declaration
export const loyaltyAssistRoutes = [
  {
    component: lazyLoyaltyAssistPage,
    path: '/loyalty-assist/history',
    title: 'Loyalty',
    needsAuth: true,
  },
  {
    component: lazyTaxHistoryPage,
    path: '/loyalty-assist/tax-history',
    title: 'Tax',
    needsAuth: true,
  },
  {
    component: lazyLoyaltyTransitionHistoryPage,
    path: '/loyalty-assist/tier-transition-history',
    title: 'Tier Transition',
    needsAuth: true,
  },
  {
    component: lazyLoyaltyUsersPage,
    path: '/loyalty-assist/loyalty-users',
    title: 'Loyalty Users',
    needsAuth: true,
  },
];
